module.exports = __webpack_public_path__ + "static/media/mono_manual_schematic_modulation.d9fd3c43.svg";